export default __webpack_public_path__ + "static/lite-graphic-097efa9817f47626397955b0bba591ad.svg";